export enum FlagNames {
    SHOW_RU_TETHER_SOCIAL_NOTIFY = 'showRuTetherSocialNotify',
    AB_TEST_LP_ONE_TAP = 'abTestLpGoogleOneTap',
    WEB_GUEST_ACCOUNTS = 'guestAccounts',
    WEB_S3_ASSETS = 'webS3Assets',
    LP_S3_ASSETS = 'lpS3Assets',
    LP_DIRECTORIES = 'lpDirectories',
    WEB_CHAT_SUPPORT = 'webChatSupport',
    WEB_CHAT_WIDGET_THEYMES = 'webChatWidgetTheymes',
    DISABLE_WEB_GUEST_ACCOUNT_WARNING = 'disableWebGuestAccountWarning',
    WEB_APPLE_ID_LOGIN = 'webAppleIdLogin',
    SHOW_REAL_LOADING_PERCENTS = 'showRealLoadingPercents',
    FINGERPRINT_ENABLED = 'fingerprintEnabled',
    CLIENT_DEATH_TIMER_ENABLED = 'clientDeathTimerEnabled',
    CONNECTION_CHECK_ENABLED = 'connectionCheckEnabled',
    CLIENT_ACCOUNT_WINDOW_ENABLED = 'clientAccountWindowEnabled',
    SITE_HUB_API_ENABLED = 'siteHubApiEnabled',
    ENABLE_SITE_DEV_TOOLS = 'enableSiteDevTools'
}
